import { Badges, H5, P } from "../../../../AbstractElements";
import { AudioTesting } from "../../../../Utils/Constants";

export default function AutoTestingTimeline() {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-location bg-info">
        <i className="icon-pulse" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="primary">{AudioTesting}</Badges>
        </div>
        <H5 className="f-w-500 m-0">{"Musical trends and predictability"}</H5>
        <P className="mb-0">{"So, the next time you listen to music, you might or might not consider how it's actively altering your mood."}</P>
        <audio controls preload="none">
          <source src={`${process.env.PUBLIC_URL}/assets/audio/horse.ogg`} type="audio/ogg" />
        </audio>
        <span className="cd-date">June 12 2024</span>
      </div>
    </div>
  );
}
